"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskDetailsFactory = void 0;
/* tslint:disable:max-file-line-count */
/* TODO: We plan to split these up once all the details are added and the split-lines are clear. */
const styled_1 = __importDefault(require("@emotion/styled"));
const diem_1 = __importDefault(require("@travelnest/diem"));
const country_code_lookup_1 = require("country-code-lookup");
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const __1 = require("../../");
const ValidationContext_1 = require("../../context/ValidationContext");
const types_1 = require("../../entities/fact/types");
const data_1 = require("../../hooks/data");
const types_2 = require("../../types");
const capability_1 = require("../../util/capability");
const capitalize_1 = require("../../util/capitalize");
const Paragraph_1 = require("../../view/components/paragraph/Paragraph");
const data_2 = require("../../view/pages/tasks/bedrooms/data");
const config_1 = require("../../view/pages/tasks/local-licence/config");
const helpers_1 = require("../../view/pages/tasks/marketing-channels/helpers");
const helpers_2 = require("../../view/pages/tasks/pricing/helpers");
const constants_1 = require("../constants");
const helpers_3 = require("./helpers");
const Spacer_1 = require("../../view/components/spacer/Spacer");
const helpers_4 = require("../../view/components/amenities/helpers");
const FRESH_DESK_DOC = 'https://travelnest.freshdesk.com/support/solutions/articles/101000362817-synchronise-your-travelnest-calendar-with-ical';
// maps to client_api/pricing/validation/MAX_GAPPY_NIGHTS https://github.com/TravelNest/client_api/blob/master/src/pricing/validation.ts
const MAX_GAPPY_NIGHTS = 21;
// maps to client_api/availability/validation/MIN_AVAILABLE_NIGHTS https://github.com/TravelNest/client_api/blob/master/src/availability/validation.ts
const MIN_AVAILABLE_NIGHTS = 10;
const DescHeading = styled_1.default.div `
	font-weight: 500;
	font-size: 1rem;
	line-height: 1.25rem;
`;
const pluralise = (n) => {
    return (n === 0 || n > 1) ? 's' : '';
};
const formatBedDescription = (count, str) => {
    return count + ' ' + (0, capitalize_1.capitalize)(`${str}${pluralise(count)}`);
};
// Details of the text and information to put inside the task box
exports.TaskDetailsFactory = {
    [constants_1.Tasks.BEDROOMS]: (property, customer, completion, capabilities) => {
        const { entityActions } = React.useContext(__1.AppContext);
        const { itemTypes } = (0, data_1.useItemTypes)(entityActions);
        if (!(itemTypes === null || itemTypes === void 0 ? void 0 : itemTypes.bed_types) || itemTypes.bed_types.length === 0) {
            return (React.createElement(Paragraph_1.Paragraph, null, "Loading..."));
        }
        else {
            const bedroomInfo = (0, data_2.bedsToEditState)(property.beds);
            switch (completion) {
                case types_1.TaskCompletionState.COMPLETE:
                    const bedroomCount = Object.keys(bedroomInfo.rooms).length;
                    const bedTypeCounts = property.beds.reduce((acc, b) => {
                        if (b.bed_type in acc) {
                            acc[b.bed_type] += 1;
                        }
                        else {
                            acc[b.bed_type] = 1;
                        }
                        return acc;
                    }, {});
                    const bedByType = Object.fromEntries(itemTypes.bed_types.map(x => [x.name, x]));
                    return React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, property.property_type === 'studio' ? 'Studio' : `${bedroomCount} bedroom${pluralise(bedroomCount)}`),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        Object.entries(bedTypeCounts).sort().map(([bedType, count]) => {
                            return React.createElement(Paragraph_1.Paragraph, { key: bedType }, formatBedDescription(count, bedByType === null || bedByType === void 0 ? void 0 : bedByType[bedType].display_name));
                        }),
                        React.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
                        React.createElement(DescHeading, null, "Maximum guests"),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null,
                            property.capacity,
                            " guest",
                            pluralise(property.capacity)));
                case types_1.TaskCompletionState.INPUT_REQUIRED:
                    return React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, "Bedrooms"),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null, property.capacity > 50 ?
                            'A maximum capacity of 50 is allowed. Please lower your available bedrooms.' :
                            'Please add your bedroom information.'));
                default:
                    return React.createElement(React.Fragment, null);
            }
        }
    },
    [constants_1.Tasks.BATHROOMS]: (property, customer, completion, capabilities) => {
        switch (completion) {
            case types_1.TaskCompletionState.COMPLETE:
                return React.createElement(React.Fragment, null, property.bathrooms.map((bathroom, i) => {
                    const features = [];
                    if (bathroom.toilet_type !== 'none')
                        features.push('toilet', 'sink');
                    if (bathroom.bath_type !== 'none')
                        features.push('bath');
                    if (bathroom.shower_type !== 'none')
                        features.push('shower');
                    if (bathroom.private_access)
                        features.push('private');
                    if (bathroom.accessible)
                        features.push('accessible');
                    return React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null,
                            "Bathroom ",
                            i + 1),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null, (0, capitalize_1.capitalize)(features.join(', '))),
                        React.createElement(Spacer_1.Spacer, { spacing: "smaller" }));
                }));
            case types_1.TaskCompletionState.INPUT_REQUIRED:
                return React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null, "Bathrooms"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, "Please add your bathroom information."));
            default:
                return React.createElement(React.Fragment, null);
        }
    },
    [constants_1.Tasks.AMENITIES_FEATURES]: (property, customer, completion, capabilities) => {
        const selectedAmenities = property.amenities.filter((amenity, index, self) => index === self.findIndex((t) => (t.amenity_type === amenity.amenity_type && amenity.is_present)));
        const amenityCount = selectedAmenities.length;
        switch (completion) {
            case types_1.TaskCompletionState.COMPLETE:
                return React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null,
                        amenityCount,
                        " amenities selected"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null,
                        selectedAmenities.splice(0, 10).map((amenity) => (0, helpers_4.amenityFullName)(amenity.amenity_type)).join(', '),
                        amenityCount > 10 ? ', ...' : '.'));
            case types_1.TaskCompletionState.REVIEW_REQUIRED:
                return React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null,
                        amenityCount,
                        " amenities selected"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, "We have selected the most popular amenities as searched for by guests. Please review to confirm."));
            default:
                return React.createElement(React.Fragment, null);
        }
    },
    [constants_1.Tasks.PROPERTY_COMPOSITION]: (property, customer, completion, capabilities, validation) => {
        switch (completion) {
            case types_1.TaskCompletionState.COMPLETE:
                const facts = [`Property has ${property.number_of_floors} floors`];
                if (!!property.entrance_floor)
                    facts.push(`, entrance is located on floor ${property.entrance_floor}`);
                if (property.has_elevator)
                    facts.push('. Property has elevator access.');
                return React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null, "Property type"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, (0, capitalize_1.capitalize)(property.property_type)),
                    React.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
                    React.createElement(DescHeading, null, "Layout"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, facts.join('')));
            case types_1.TaskCompletionState.INPUT_REQUIRED:
                return React.createElement(React.Fragment, null,
                    !validation.property.fields.property_type && React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, "Property type"),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null, "Property type not set")),
                    !validation.property.fields.property_size && React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, "Property size"),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null, "Property size not set")));
            default:
                return React.createElement(React.Fragment, null);
        }
    },
    [constants_1.Tasks.LOCATION]: (property, customer, completion, capabilities) => {
        switch (completion) {
            case types_1.TaskCompletionState.COMPLETE:
            case types_1.TaskCompletionState.REVIEW_REQUIRED:
                return React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null, "Property address"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, property.address1),
                    property.address2 && React.createElement(Paragraph_1.Paragraph, null, property.address2),
                    React.createElement(Paragraph_1.Paragraph, null, property.city),
                    React.createElement(Paragraph_1.Paragraph, null, property.postcode),
                    React.createElement(Paragraph_1.Paragraph, null, (0, country_code_lookup_1.byIso)(property.country_code).country));
            case types_1.TaskCompletionState.INPUT_REQUIRED:
                return React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null, "Property location"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, "Please tell us your property location."));
            default:
                return React.createElement(React.Fragment, null);
        }
    },
    [constants_1.Tasks.LOCAL_LICENCE]: (property, customer, completion, capabilities) => {
        if (completion === types_1.TaskCompletionState.DISABLED) {
            return 'Your property does not require local licence information.';
        }
        if (!property.country_code ||
            !(Object.keys(config_1.LocalLicenceCountries).includes(property.country_code) ||
                Object.keys(config_1.LocalLicenceOptionalCountries).includes(property.country_code))) {
            return React.createElement(Paragraph_1.Paragraph, null, "Your property does not require a local licence");
        }
        else {
            if (completion === types_1.TaskCompletionState.COMPLETE && !!property.local_licence) {
                if (property.country_code === 'GB') {
                    return React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, "Local licence"),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null, "You can optionally provide local licence information about your property."));
                }
                if (property.country_code === 'ES') {
                    const localLicence = property.local_licence;
                    return React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, "Local licence"),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null,
                            "Tax ID: ",
                            property.local_licence.identification_number),
                        React.createElement(Paragraph_1.Paragraph, null,
                            "Cadastral reference number: ",
                            localLicence.cadastral_reference_number),
                        localLicence.is_in_region_requiring_tourist_licence
                            ? React.createElement(Paragraph_1.Paragraph, null,
                                "Local licence number: ",
                                property.local_licence.number)
                            : React.createElement(React.Fragment, null),
                        React.createElement(Paragraph_1.Paragraph, null, "We have your local licence information."));
                }
                else {
                    return React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, "Local licence"),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null,
                            "Local licence number: ",
                            property.local_licence.number),
                        property.country_code === 'PT'
                            ? React.createElement(Paragraph_1.Paragraph, null,
                                "Tax ID: ",
                                property.local_licence.identification_number)
                            : React.createElement(React.Fragment, null),
                        React.createElement(Paragraph_1.Paragraph, null, "We have your local licence information."));
                }
            }
            else {
                if (Object.keys(config_1.LocalLicenceOptionalCountries).includes(property.country_code)) {
                    return React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, "Local licence"),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null, "You can optionally provide local licence information about your property."));
                }
                return React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null, "Local licence"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, "Your country requires local licensing information. This must be filled out before you are ready to go live."));
            }
        }
    },
    [constants_1.Tasks.ARRIVALS_DEPARTURES]: (property, customer, completion, capabilities) => {
        return React.createElement(React.Fragment, null,
            React.createElement(DescHeading, null, "Arrival time"),
            React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
            React.createElement(Paragraph_1.Paragraph, null,
                "after ",
                property.check_in),
            React.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
            React.createElement(DescHeading, null, "Departure time"),
            React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
            React.createElement(Paragraph_1.Paragraph, null,
                "before ",
                property.check_out));
    },
    [constants_1.Tasks.HOUSE_RULES]: (property, customer, completion, capabilities) => {
        var _a, _b;
        const children = (_a = property.restrictions) === null || _a === void 0 ? void 0 : _a.find(p => p.restriction_type === 'children allowed');
        const childrenAllowed = children ? children.allowed : false;
        const infants = (_b = property.restrictions) === null || _b === void 0 ? void 0 : _b.find(p => p.restriction_type === 'infants allowed');
        const infantsAllowed = infants ? infants.allowed : false;
        return React.createElement(React.Fragment, null,
            React.createElement(DescHeading, null, "House rules"),
            React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
            React.createElement(Paragraph_1.Paragraph, null, (0, helpers_3.getChildrenAndInfantsHouseRules)(childrenAllowed, infantsAllowed)),
            React.createElement(Paragraph_1.Paragraph, null, (0, helpers_3.hasAllowedRestriction)('pets', property.restrictions) ? 'Pets are allowed.' : 'Pets are not allowed.'),
            React.createElement(Paragraph_1.Paragraph, null, (0, helpers_3.hasAllowedRestriction)('smoking', property.restrictions) ? 'Smoking is allowed.' : 'Smoking is not allowed.'),
            React.createElement(Paragraph_1.Paragraph, null, (0, helpers_3.hasAllowedRestriction)('group bookings', property.restrictions) ? 'Parties are allowed.' : 'Parties are not allowed.'));
    },
    [constants_1.Tasks.PRICING]: (property, customer, completion, capabilities) => {
        const nodes = [];
        if ((0, capability_1.hasCapability)(capabilities, types_2.DashboardCapabilities.DisablePricing)) {
            nodes.push(React.createElement(DescHeading, null, "Your pricing is managed externally. Make all changes there."));
        }
        const pricingType = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = state.data.pricingType) === null || _a === void 0 ? void 0 : _a.byPropertyId[property.id]; });
        if ((pricingType === null || pricingType === void 0 ? void 0 : pricingType.type) === 'automatic') {
            if (completion === types_1.TaskCompletionState.INPUT_REQUIRED) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null, "This property has no pricing."),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, "We're missing some preferences.")));
            }
            else {
                return React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null, "This property has pricing."),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, "Smart pricing has been set for the next 365 days."));
            }
        }
        else { // manual pricing
            const pricingValidation = (0, react_redux_1.useSelector)((state) => state.data.pricingValidation.byPropertyId[property.id]);
            const endHuman = (pricingValidation && pricingValidation.end) ? (0, helpers_2.humanizeDateFormat)(pricingValidation.end) : '';
            switch (completion) {
                case types_1.TaskCompletionState.COMPLETE:
                    nodes.push(React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, "This property has pricing."),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null,
                            "Pricing exists up to ",
                            endHuman)));
                    break;
                case types_1.TaskCompletionState.INPUT_REQUIRED:
                    const sixMonthsFromToday = new diem_1.default();
                    sixMonthsFromToday.setMonth(sixMonthsFromToday.getMonth() + 6);
                    const fourMonthsFromToday = new diem_1.default();
                    fourMonthsFromToday.setMonth(fourMonthsFromToday.getMonth() + 4);
                    const gapsStartingInNext6Months = pricingValidation.gaps.filter((g) => new diem_1.default(g.from).diff(sixMonthsFromToday) < 0);
                    const gaps = gapsStartingInNext6Months.length;
                    if (!pricingValidation.present) {
                        nodes.push(React.createElement(Paragraph_1.Paragraph, null, "This property has no pricing"));
                        return nodes;
                    }
                    const out = [];
                    // Not enough pricing
                    if (new diem_1.default(pricingValidation.end).diff(fourMonthsFromToday) < 0) {
                        out.push(React.createElement(Paragraph_1.Paragraph, null,
                            "Your pricing runs out on ",
                            endHuman,
                            ". You need at least 4 months of pricing to remain live on channels - we recommend having 18 months of future pricing at all times."));
                    }
                    if (gaps > 0) {
                        out.push(React.createElement(React.Fragment, null,
                            "This property has ",
                            gaps,
                            " ",
                            gaps === 1 ? 'gap' : 'gaps',
                            " for the next 6 months",
                            gapsStartingInNext6Months.map((g) => {
                                return React.createElement(Paragraph_1.Paragraph, null,
                                    "Gap starting on ",
                                    (0, helpers_2.humanizeDateFormat)(g.from));
                            }),
                            React.createElement(Paragraph_1.Paragraph, null,
                                "You are missing at least ",
                                MAX_GAPPY_NIGHTS,
                                " days of pricing over the next 4 months. You must resolve these pricing gaps to be able to publish your property.")));
                    }
                    if (out.length === 0) {
                        out.push(React.createElement(Paragraph_1.Paragraph, null, "There is a problem with your pricing"));
                    }
                    nodes.push(React.createElement(React.Fragment, null, out.map((o) => o)));
                    break;
                case types_1.TaskCompletionState.REVIEW_REQUIRED:
                default:
                    nodes.push(React.createElement("div", null));
                    break;
            }
            return nodes;
        }
    },
    [constants_1.Tasks.CLEANING_FEE]: (property, customer, completion, capabilities) => {
        var _a;
        const cleaningFee = (_a = property === null || property === void 0 ? void 0 : property.restrictions) === null || _a === void 0 ? void 0 : _a.find((res) => res.restriction_type === 'cleaning fee');
        return (cleaningFee
            ? (React.createElement(React.Fragment, null,
                React.createElement(DescHeading, null, "This property has a cleaning fee."),
                React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                React.createElement(Paragraph_1.Paragraph, null, cleaningFee.charge)))
            : 'This property has no cleaning fee.');
    },
    [constants_1.Tasks.SECURITY_DEPOSIT]: (property, customer, completion) => {
        return (property.security_deposit
            ? (React.createElement(React.Fragment, null,
                React.createElement(DescHeading, null,
                    "This property has a security deposit of ",
                    property.security_deposit,
                    "."),
                React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                React.createElement(Paragraph_1.Paragraph, { style: { maxWidth: 'unset' } },
                    "TravelNest collects and manages security deposits for Airbnb and Tripadvisor only. For all other channels, ",
                    React.createElement("strong", null, "it is your responsibility"),
                    " to collect security deposits from your guests.")))
            : 'This property has no security deposit.');
    },
    [constants_1.Tasks.TOURIST_TAX]: (property, customer, completion, capabilities) => {
        var _a;
        const touristTax = (_a = property === null || property === void 0 ? void 0 : property.restrictions) === null || _a === void 0 ? void 0 : _a.find((res) => res.restriction_type === 'tourist tax' && res.allowed === true);
        return (touristTax
            ? 'This property has a tourist tax.'
            : 'This property has no tourist tax.');
    },
    [constants_1.Tasks.INTERNAL_NAME]: (property, customer, completion, capabilities) => property.internal_name || 'This property needs a nickname.',
    [constants_1.Tasks.PHOTOS]: (property, customer, completion) => {
        const count = React.useContext(ValidationContext_1.ValidationContext).state.images.count;
        switch (completion) {
            case types_1.TaskCompletionState.COMPLETE:
                return `This property has ${count} photos.`;
            case types_1.TaskCompletionState.INPUT_REQUIRED:
                return (React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null,
                        "This property has ",
                        count,
                        " photos."),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, "This property must have 10 photos.")));
            default:
                return React.createElement("div", null);
        }
    },
    [constants_1.Tasks.LISTING_HEADLINE]: (property, customer, completion, capabilities) => property.name || 'This property needs a headline.',
    [constants_1.Tasks.LISTING_DESCRIPTION]: (property, customer, completion, capabilities) => {
        var _a, _b;
        switch (completion) {
            case types_1.TaskCompletionState.COMPLETE:
                return (React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null, "Description preview"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, ((_a = property === null || property === void 0 ? void 0 : property.long_description) === null || _a === void 0 ? void 0 : _a.length) >= 200
                        ? `${(_b = property === null || property === void 0 ? void 0 : property.long_description) === null || _b === void 0 ? void 0 : _b.substring(0, 200)}...`
                        : property === null || property === void 0 ? void 0 : property.long_description)));
            case types_1.TaskCompletionState.REVIEW_REQUIRED:
                return (React.createElement(React.Fragment, null,
                    React.createElement(DescHeading, null, "Description"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                    React.createElement(Paragraph_1.Paragraph, null, "We have created a description for you. Take a moment to review it and make any changes.")));
            case types_1.TaskCompletionState.INPUT_REQUIRED:
                return 'This property needs a description.';
            default:
                return React.createElement("div", null);
        }
    },
    [constants_1.Tasks.BOOKING_AVAILABILITY]: (property, customer, completion, capabilities) => {
        const propertySummary = (0, react_redux_1.useSelector)((state) => state.data.propertySummaries.byId[property.id]);
        switch (completion) {
            case types_1.TaskCompletionState.COMPLETE:
                if ((0, capability_1.hasCapability)(capabilities, types_2.DashboardCapabilities.DisableAvailability)) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, "View your booking availability here."),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null, "You can make updates to your availability in SuperControl.")));
                }
                return (React.createElement(Paragraph_1.Paragraph, null,
                    "Keep your calendar up to date. To avoid double bookings, any listings outside TravelNest ",
                    React.createElement("strong", null, "must be connected to your TravelNest calendar using iCal sync."),
                    ' ',
                    "Our ",
                    React.createElement("a", { href: FRESH_DESK_DOC }, "iCal sync guide"),
                    ' ',
                    "has more information."));
            case types_1.TaskCompletionState.INPUT_REQUIRED:
                if (propertySummary && propertySummary.validation.availability.availableNights < MIN_AVAILABLE_NIGHTS) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null,
                            "This property has ",
                            propertySummary.validation.availability.availableNights,
                            " nights available for booking in the next 12 months."),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null, "Your availability is low - make at least 10 nights available")));
                }
                else {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(DescHeading, null, "This property's availability has not been updated."),
                        React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                        React.createElement(Paragraph_1.Paragraph, null, "Please add your blocked dates.")));
                }
            default:
                return (React.createElement(Paragraph_1.Paragraph, null,
                    "Keep your calendar up to date. To avoid double bookings, any listings outside TravelNest ",
                    React.createElement("strong", null, "must be connected to your TravelNest calendar using iCal sync."),
                    ' ',
                    "Our ",
                    React.createElement("a", { href: FRESH_DESK_DOC }, "iCal sync guide"),
                    ' ',
                    "has more information."));
        }
    },
    [constants_1.Tasks.BOOKING_NOTICE]: (property, customer, completion, capabilities) => property.advance_bookings
        ? `There is a ${property.advance_bookings} day booking notice.`
        : '',
    [constants_1.Tasks.CHANNEL_SELECTION]: (property, customer, completion, capabilities) => {
        // @ts-ignore https://github.com/microsoft/TypeScript/issues/42790
        const { entityActions } = React.useContext(__1.AppContext);
        const { channelData } = (0, data_1.useChannelSelectionData)(entityActions, customer);
        if (!channelData || channelData.length === 0) {
            return (React.createElement(Paragraph_1.Paragraph, null,
                "You must have at least one channel selected.",
                ' ',
                "If you have separate listings outside TravelNest, these must be connected to your TravelNest calendar using iCal sync."));
        }
        else {
            const channelCount = (0, helpers_1.getChannelsCount)(channelData);
            return React.createElement(Paragraph_1.Paragraph, null, `This property will be listed on ${channelCount} channel${pluralise(channelCount)}.`);
        }
    },
    [constants_1.Tasks.PROMOTIONS]: (property, customer, completion, capabilities) => {
        return (React.createElement(Paragraph_1.Paragraph, null, "Promotions are a great way to attract customers and increase bookings, take a look at what the channels have to offer."));
    },
    [constants_1.Tasks.COMMISSION]: (property, customer, completion, capabilities) => (React.createElement(Paragraph_1.Paragraph, null, "Learn more about TravelNest fees.")),
    [constants_1.Tasks.PERSONAL_DETAILS]: (property, customer, completion, capabilities) => {
        if (completion === types_1.TaskCompletionState.COMPLETE) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Paragraph_1.Paragraph, null,
                    "Full Name: ",
                    customer.name),
                React.createElement(Paragraph_1.Paragraph, null,
                    "Email: ",
                    customer.email),
                React.createElement(Paragraph_1.Paragraph, null,
                    "Phone Number: ",
                    customer.phone)));
        }
        else if (completion === types_1.TaskCompletionState.REVIEW_REQUIRED) {
            return (React.createElement(React.Fragment, null,
                "Here is the contact information we have for you.",
                React.createElement(Paragraph_1.Paragraph, null,
                    "Full Name: ",
                    customer.name),
                React.createElement(Paragraph_1.Paragraph, null,
                    "Email: ",
                    customer.email),
                React.createElement(Paragraph_1.Paragraph, null,
                    "Phone Number: ",
                    customer.phone)));
        }
        else {
            return (React.createElement(React.Fragment, null,
                "We are missing some contact information:",
                React.createElement(Paragraph_1.Paragraph, null, customer.name ? '' : 'Missing [Full Name]'),
                React.createElement(Paragraph_1.Paragraph, null, customer.email ? '' : 'Missing [Email]'),
                React.createElement(Paragraph_1.Paragraph, null, customer.phone ? '' : 'Missing [Phone Number]')));
        }
    },
    [constants_1.Tasks.TERMS_CONDITIONS]: (property, customer, completion, capabilities) => {
        const validationContext = React.useContext(ValidationContext_1.ValidationContext);
        const message = (validationContext.state && validationContext.state.terms.valid)
            ? 'You have agreed to the terms and conditions.'
            : 'You must agree to the terms and conditions.';
        return React.createElement(Paragraph_1.Paragraph, null, message);
    },
};
//# sourceMappingURL=index.js.map